import { AutogenModelOrdersLookup, AutogenRowOrdersLookup } from "./autogen/AutogenModelOrdersLookup";

export class ModelOrdersLookup extends AutogenModelOrdersLookup<RowOrdersLookup> {
    constructor() {
        super(RowOrdersLookup);
    }
}

export class RowOrdersLookup extends AutogenRowOrdersLookup {
}